module.exports = __webpack_public_path__ + "img/loginBG.png";